/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import DashboardService from '../services/DashboardService';
import moment from "moment";
import { showLoading } from 'react-global-loading';
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class AyushGlobal extends React.Component {
  constructor(props) {
    super(props);
    showLoading(false);
    this.state = {
      data: ''
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.getData();
  };

  getData = () => {
    DashboardService.getAyushGlobal()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ data: result.data });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  render() {
    const { data } = this.state;
    return (
      <div className="container">
        <h2 className="abthdn">About Ayush Global Project</h2>
        <div dangerouslySetInnerHTML={{ __html: data?.content?.rendered }} />
      </div>
    );
  }
}
export default AyushGlobal;